var map = {
	"./home_item_bg_1.svg": "ylz7",
	"./home_item_bg_2.svg": "kWeD",
	"./home_item_bg_3.svg": "1d/q",
	"./home_item_bg_4.svg": "7B4P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BFCq";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/imgs ^\.\/home_item_bg_.*\.svg$
// module id = BFCq
// module chunks = 0